import { render, staticRenderFns } from "./viewPUBLI.vue?vue&type=template&id=7c46661a&scoped=true"
import script from "./viewPUBLI.vue?vue&type=script&lang=js"
export * from "./viewPUBLI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46661a",
  null
  
)

export default component.exports